import{RP_TPA_DAILY_MODEL_LIST, RP_TPA_DAILY_PAGINATION, RP_TPA_DAILY_SEARCH}from './actionType'

export const setModelDeviceListToState = (payload) => ({
    type: RP_TPA_DAILY_MODEL_LIST,
    payload
})

export const setSearchToState = (payload) => ({
    type: RP_TPA_DAILY_SEARCH,
    payload
})
export const setPaginationToState = (payload) => ({
    type: RP_TPA_DAILY_PAGINATION,
    payload
})
